import { HttpClient } from '@adapters/HttpClient';

export interface ClientBankAccount {
    id: number;
    team_id: number;
    holder_name: string;
    iban: string;
    bic: string;
    bank_name: string;
    country_code: string;
    status: 'PENDING' | 'VERIFIED' | 'REJECTED' | 'DISABLED' | string;
    proof_document_path: string | null;
    verified_by_user_id: number | null;
    verified_at: string | null;
    rejected_reason: string | null;
    internal_note: string | null;
    verified_by_user: any | null;
    team?: {
        id: number;
        name: string;
    };
}

export interface ClientBankAccountsResponse {
    data: ClientBankAccount[];
    meta: {
        current_page: number;
        per_page: number;
        total: number;
    };
}

export class ClientBankAccountsApiAdapter {
    constructor(private httpClient: HttpClient) {}

    async getBankAccountsByTeamId(teamId: number, page = 1, perPage = 15): Promise<ClientBankAccountsResponse> {
        const params: Record<string, any> = {
            per_page: perPage,
            page,
            team_id: teamId,
            'sorting[column]': 'id',
            'sorting[direction]': 'desc',
        };

        const response = await this.httpClient.get<ClientBankAccountsResponse>('/bank_accounts', params);
        return response;
    }
}

